import { render, staticRenderFns } from "./invitation.vue?vue&type=template&id=e7efdea2&scoped=true"
import script from "./invitation.vue?vue&type=script&lang=ts"
export * from "./invitation.vue?vue&type=script&lang=ts"
import style0 from "./invitation.vue?vue&type=style&index=0&id=e7efdea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7efdea2",
  null
  
)

export default component.exports